import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";
import GetCocForPas from "../services/GetCocForPas";
import GetCocForMis from "../services/GetCocForMis";
import GetCocForOds from "../services/GetCocForOds";
import Title from "../components/CoC-Details/Title";
import PolicyDetails from "../components/CoC-Details/PolicyDetails";
import ProductDetails from "../components/CoC-Details/ProductDetails";
import BenefitDetails from "../components/CoC-Details/BenefitDetails";
import Footer from "../components/CoC-Details/Footer";
import { coc, printIcon } from "../components/Shared/Styles";
import { GelIcon } from "@tal-gel/components";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Print = () => {
  let printContents = document.getElementById("COC").innerHTML;
  let myWindow = window.open("COC", "_blank");
  myWindow.document.write("<html><head><title></title>");
  myWindow.document.write('<style type="text/css" media="print"> @page { size: auto; margin: 1.4cm; }</style>');
  myWindow.document.write("</head><body style='width: 1020px; font-family: Pluto Sans Condensed, Arial, sans-serif; font-size: 14px;'>");
  myWindow.document.write(printContents);
  myWindow.document.write("<hr style='border-top: 1px solid black'>");
  myWindow.document.write("</body></html>");
  myWindow.focus();
  myWindow.window.print();
  myWindow.close();
};

export default function CertificateOfCurrency(props) {
  let query = useQuery();
  let { url } = useRouteMatch();

  const [policyDetails, setPolicyDetails] = useState();
  const [benefitDetails, setBenefitDetails] = useState();
  const [productDetails, setProductDetails] = useState();

  const [policyNumber] = useState(query.get("policyNumber"));
  const [policyStatus] = useState(query.get("policyStatus"));
  const [policyOrigin] = useState(query.get("policyOrigin"));
  const [distributorNo] = useState(query.get("distributorNo"));

  const [accessToken] = useState(
    document.getElementById("accessToken")
        ? document.getElementById("accessToken").innerHTML
        : ""
  );

  const [oktaIdToken] = useState(
    document.getElementById("oktaIdToken")
        ? document.getElementById("oktaIdToken").innerHTML
        : ""
  );

  const retrieveCocResult = useCallback(async () => {
    if (policyStatus === null || policyStatus.toLowerCase() === undefined) {
      policyStatus = "in force";
    }
    if (policyOrigin === "TLIS" || policyOrigin === "ASTERON"){
      const result = await GetCocForOds(        
        policyNumber,
        distributorNo,
        accessToken,
        oktaIdToken
      );

      if (result) {
        if (result.benefitDetails) {
          await setBenefitDetails(result.benefitDetails);
        }

        if (result.policyDetails) {
          await setPolicyDetails(result.policyDetails);
        }

        if (result.productDetails) {
          await setProductDetails(result.productDetails);
        }
      }
    }
    else if (policyStatus.toLowerCase() === "in suspense" || policyStatus.toLowerCase() === "proposal") {
      const result = await GetCocForPas(        
        policyNumber,
        distributorNo,
        accessToken,
        oktaIdToken
      );

      if (result) {
        if (result.benefitDetails) {
          await setBenefitDetails(result.benefitDetails);
        }

        if (result.policyDetails) {
          await setPolicyDetails(result.policyDetails);
        }

        if (result.productDetails) {
          await setProductDetails(result.productDetails);
        }
      }
    } else {
      const result = await GetCocForMis(        
        policyNumber,
        distributorNo,
        accessToken,
        oktaIdToken
      );

      if (result) {
        if (result.benefitDetails) {
          await setBenefitDetails(result.benefitDetails);
        }

        if (result.policyDetails) {
          await setPolicyDetails(result.policyDetails);
        }

        if (result.productDetails) {
          await setProductDetails(result.productDetails);
        }
      }
    }
  }, []);

  useEffect(() => {
    retrieveCocResult();
  }, [retrieveCocResult]);

  return (
    <div>
        <div style={printIcon}>
          <GelIcon onClick={Print} name="ActionsToolsPrint" brand />
          <div style={{ marginLeft: "7px" }}>Print</div>
        </div>

        <div id="COC" style={coc}>
          <div style={{ marginBottom: "40px" }}>
            {productDetails && <Title productDetails={productDetails} />}
          </div>

          <div style={{ marginBottom: "30px" }}>
            <span>
              {policyDetails && <PolicyDetails policyDetails={policyDetails} />}
            </span>
          </div>

          <div style={{ marginBottom: "30px" }}>
            <span>
              {productDetails && (
                <ProductDetails productDetails={productDetails} policyOrigin={policyOrigin} />
              )}
            </span>
          </div>

          <div style={{ marginBottom: "30px" }}>
            <span>
              {benefitDetails && (
                <BenefitDetails benefitDetails={benefitDetails} policyOrigin={policyOrigin}  productDetails={productDetails}/>
              )}
            </span>
          </div>

          <div>
            <span style={{ marginLeft: "46px" }}>
              {policyDetails && productDetails && (
                <Footer
                  policyDetails={policyDetails}
                  productDetails={productDetails}
                  policyOrigin={policyOrigin}
                />
              )}
            </span>
          </div>
        </div>
    </div>
  );
}
